import template from './prems-premium-item-statistic-hint.html.twig';

const { Component } = Shopware;

Component.register('prems-premium-item-statistic-hint', {
    template,

    methods: {
        onClickStatisticButton() {
            this.$router.push({'name': 'prems.premium.item.index'});
        }
    }
});